module.exports = __webpack_public_path__ + "img/bullet.054f2094.svg";